/* istanbul ignore file */
import type { GenericTrackingEvent } from '@packages/tracking';
import { useTracking } from '@packages/tracking';
import { useEffect } from 'react';
import type { RdeType } from '../../types';

type GtmEvent = {
  sourceCategoryId?: string | number;
  rdeTypeAbbr: string;
  outputElementNo: number;
};

type TrackingProps = {
  rdeType: RdeType;
  elementIndex?: number;
  sourceCategoryId: string | number;
  trackingCondition: boolean;
};

export const useBrandsRecoTracking = ({
  rdeType,
  elementIndex,
  sourceCategoryId,
  trackingCondition,
}: TrackingProps) => {
  const dispatchGTMEvent = useTracking();

  useEffect(() => {
    if (trackingCondition && elementIndex) {
      dispatchGTMEvent<GenericTrackingEvent<GtmEvent>>({
        event: 'ga_event',
        eventAction: 'view',
        eventCategory: 'elementImpression',
        eventLabel: 'brandRecoImpression',
        eventValue: {
          rdeTypeAbbr: rdeType,
          outputElementNo: (elementIndex ?? 0) + 1,
          sourceCategoryId,
        },
      });
    }
  }, [trackingCondition, elementIndex, dispatchGTMEvent, rdeType, sourceCategoryId]);
};
